import ModalController from "./modal_controller"
import { template } from "lodash"

export default class extends ModalController {
  static targets = [...ModalController.targets, "invoicesButton", "warehouseDocsButton", "content", "sentToKsefNotice", "postedInvoicesNotice", "noticeWithInvoiceList",
    "noticeWithoutInvoiceList", "invoiceListElementTemplate", "sentInvoicesList", "buttonTextTemplate", "postedInvoicesList",
    "ksefExpenseNotice"]

  static values = {
    ...ModalController.values,
    translations: Object,
    invoices: Object,
    postCheck: Boolean,
    bulkDeleteUrl: String
  }

  static outlets = ["list--bulk"]

  invoicesToDelete = []
  invoicesSentToKsef = []
  sentInvoiceHasWd = []
  invoicesToDeleteWithWd = []
  invoicesPosted = []
  postedInvoiceHasWd = []
  ksefExpenses = []

  connect() {
    super.connect()

    if (this.hasNoticeWithInvoiceListTarget) {
      this.noticeWithInvoiceListTemplate = template(this.noticeWithInvoiceListTarget.innerHTML)
    }
    if (this.hasNoticeWithoutInvoiceListTarget) {
      this.noticeWithoutInvoiceListTemplate = template(this.noticeWithoutInvoiceListTarget.innerHTML)
    }
    if (this.hasInvoiceListElementTemplateTarget) {
      this.invoiceListElementTemplate = template(this.invoiceListElementTemplateTarget.innerHTML)
    }
    if (this.hasButtonTextTemplateTarget) {
      this.buttonTextTemplate = template(this.buttonTextTemplateTarget.innerHTML)
    }
    if (this.hasKsefExpenseNoticeTarget) {
      this.ksefExpenseNoticeTemplate = template(this.ksefExpenseNoticeTarget.innerHTML)
    }
  }

  open() {
    super.open()

    if (this.hasListBulkOutlet) {
      this.loadBulkDeleteContent()
    }
  }

  loadBulkDeleteContent() {
    this.hideInvoiceButton()
    this.hideWarehouseDocsButton()
    const invoices = this.listBulkOutlet.selectedRecords
    this.invoicesSentToKsef = []
    this.sentInvoiceHasWd = []
    this.invoicesToDelete = []
    this.invoicesToDeleteWithWd = []
    this.invoicesPosted = []
    this.postedInvoiceHasWd = []
    this.ksefExpenses = []
    let text = ""

    for (let i = 0; i < invoices.length; i++) {
      const invoiceData = this.invoicesValue[invoices[i]]
      const trline = document.getElementById("trline" + invoices[i])
      const link = trline.getAttribute("data-xs-link-url-value")
      const number = document.getElementById("invoice_number_" + invoices[i]).text
      if (this.invoiceSentToKsef(invoiceData)) {
        this.invoicesSentToKsef.push({ number, link })

        if (invoiceData["warehouse_document_id"] !== null) {
          this.sentInvoiceHasWd.push(invoices[i])
        }
      }
      if (this.invoicePosted(invoiceData)) {
        this.invoicesPosted.push({ number, link })

        if (invoiceData["warehouse_document_id"] !== null) {
          this.postedInvoiceHasWd.push(invoices[i])
        }
      }
      // wydatki pobrane z KSeF — zbieramy do ostrzeżenia (nie blokujemy usunięcia)
      if (invoiceData["ksef_expense"]) {
        this.ksefExpenses.push({ number, link })
      }
      if (!this.invoiceSentToKsef(invoiceData) && !this.invoicePosted(invoiceData)) {
        this.invoicesToDelete.push(invoices[i])
        if (invoiceData["warehouse_document_id"] !== null) {
          this.invoicesToDeleteWithWd.push(invoices[i])
        }
      }
    }

    if (this.invoicesSentToKsef.length > 0 || this.invoicesPosted.length > 0) {
      this.contentTarget.innerHTML = this.noticeWithInvoiceListTemplate()
      if (this.invoicesSentToKsef.length > 0) {
        for (let i = 0; i < this.invoicesSentToKsef.length; i++) {
          this.sentInvoicesListTarget.innerHTML += this.invoiceListElementTemplate(this.invoicesSentToKsef[i])
          if (i + 1 < this.invoicesSentToKsef.length) {
            this.sentInvoicesListTarget.innerHTML += ", "
          }
        }
        this.sentToKsefNoticeTarget.classList.remove("hidden")
      } else {
        this.sentToKsefNoticeTarget.classList.add("hidden")
      }

      if (this.invoicesPosted.length > 0) {
        for (let i = 0; i < this.invoicesPosted.length; i++) {
          this.postedInvoicesListTarget.innerHTML += this.invoiceListElementTemplate(this.invoicesPosted[i])
          if (i + 1 < this.invoicesPosted.length) {
            this.postedInvoicesListTarget.innerHTML += ", "
          }
        }
        this.postedInvoicesNoticeTarget.classList.remove("hidden")
      } else {
        this.postedInvoicesNoticeTarget.classList.add("hidden")
      }

      if (this.invoicesToDelete.length > 0) {
        this.showInvoiceButton()
        this.invoicesButtonTarget.innerHTML = this.buttonTextTemplate({ text: this.translationsValue["gov_group_delete_delete_others"] })
        if (this.invoicesToDeleteWithWd.length > 0) {
          this.showWarehouseDocsButton()
          this.warehouseDocsButtonTarget.innerHTML = this.buttonTextTemplate({ text: this.translationsValue["gov_group_delete_delete_others_with_wd"] })
        }
      } else {
        if (this.invoicesSentToKsef.length > 0 && this.invoicesPosted.length > 0) {
          if (this.identicalSentAndPosted(this.invoicesSentToKsef, this.invoicesPosted)) {
            text = this.translationsValue["gov_group_delete_only_sent_and_posted"]
          } else {
            text = this.translationsValue["gov_group_delete_only_sent_or_posted"]
          }
        } else if (this.invoicesSentToKsef.length > 0) {
          text = this.translationsValue["gov_group_delete_only_sent"]
        } else {
          text = this.translationsValue["group_delete_only_posted"]
        }

        if (this.sentInvoiceHasWd.length > 0 || this.postedInvoiceHasWd.length > 0) {
          text = text + " " + this.translationsValue["gov_group_delete_only_wd_for_sent"]
        }
        this.contentTarget.innerHTML = this.noticeWithoutInvoiceListTemplate({ text })
        this.hideInvoiceButton()
        if (this.sentInvoiceHasWd.length > 0 || this.postedInvoiceHasWd.length > 0) {
          this.showWarehouseDocsButton()
          this.warehouseDocsButtonTarget.innerHTML = this.buttonTextTemplate({ text: this.translationsValue["gov_group_delete_only_wd"] })
        } else {
          this.hideWarehouseDocsButton()
        }
      }
    } else {
      this.contentTarget.innerHTML = ""
      this.showInvoiceButton()
      this.invoicesButtonTarget.innerHTML = this.buttonTextTemplate({ text: this.translationsValue["group_delete_invoice_only"] })
      if (this.invoicesToDeleteWithWd.length > 0) {
        this.showWarehouseDocsButton()
        this.warehouseDocsButtonTarget.innerHTML = this.buttonTextTemplate({ text: this.translationsValue["group_delete_with_wd"] })
      }
    }

    // ostrzeżenie o wydatkach pobranych z KSeF (nie blokuje, tylko ostrzega)
    if (this.ksefExpenses.length > 0 && this.hasKsefExpenseNoticeTarget) {
      const noticeHtml = this.ksefExpenseNoticeTemplate()
      this.contentTarget.insertAdjacentHTML("beforeend", noticeHtml)
      const listTarget = this.contentTarget.querySelector("[data-invoice-bulk-delete-target='ksefExpenseList']")
      if (listTarget) {
        for (let i = 0; i < this.ksefExpenses.length; i++) {
          listTarget.innerHTML += this.invoiceListElementTemplate(this.ksefExpenses[i])
          if (i + 1 < this.ksefExpenses.length) {
            listTarget.innerHTML += ", "
          }
        }
      }
    }
  }

  invoiceSentToKsef(invoiceData) {
    const val = invoiceData["sent_to_ksef"]
    return val
  }

  invoicePosted(invoiceData) {
    const val = invoiceData["document_posted"] && !this.postCheckValue
    return val
  }

  showInvoiceButton() {
    this.invoicesButtonTarget.classList.remove("hidden")
  }

  hideInvoiceButton() {
    this.invoicesButtonTarget.classList.add("hidden")
  }

  showWarehouseDocsButton() {
    if (this.hasWarehouseDocsButtonTarget) {
      this.warehouseDocsButtonTarget.classList.remove("hidden")
    }
  }

  hideWarehouseDocsButton() {
    if (this.hasWarehouseDocsButtonTarget) {
      this.warehouseDocsButtonTarget.classList.add("hidden")
    }
  }

  identicalSentAndPosted(array1, array2) {
    const s1 = new Set(array1.map(el => el.number))
    const s2 = new Set(array2.map(el => el.number))

    if (s1.size !== s2.size) {
      return false
    }

    for (const el of s1) {
      if (!s2.has(el)) {
        return false
      }
    }

    return true
  }

  invoiceButtonSubmit(event) {
    event.preventDefault()
    let message
    if (this.ksefExpenses.length > 0) {
      message = this.translationsValue["ksef_expense_group_delete_confirm_warning"]
    } else if (this.invoicesSentToKsef.length === 0 && this.invoicesPosted.length === 0) {
      message = this.translationsValue["group_delete_confirm"]
    } else {
      message = this.translationsValue["group_delete_others_confirm"]
    }
    if (confirm(message)) {
      // DELETE /invoices/bulk_delete z jawną listą faktur do usunięcia (mode=default).
      this.listBulkOutlet.submitBulkForIds(this.invoicesToDelete, {
        url: this.bulkDeleteUrlValue,
        httpMethod: "delete",
        fields: { mode: "default" }
      })
    }
  }

  warehouseDocsButtonSubmit(event) {
    //dodać jeszcze przejście po posted
    event.preventDefault()
    let message
    let invoicesToCheck
    if (this.ksefExpenses.length > 0) {
      message = this.translationsValue["ksef_expense_group_delete_confirm_warning"]
    } else if (this.invoicesSentToKsef.length === 0 && this.invoicesPosted.length === 0) {
      message = this.translationsValue["group_delete_with_wd_confirm"]
    } else if ((this.invoicesSentToKsef.length > 0 || this.invoicesPosted.length > 0) && this.invoicesToDelete.length > 0) {
      message = this.translationsValue["group_delete_others_with_wd_confirm"]
    } else {
      message = this.translationsValue["group_delete_wd_confirm"]
    }
    if (confirm(message)) {
      let mode
      if (this.invoicesToDelete.length === 0 && this.sentInvoiceHasWd.length > 0) {
        // same dokumenty magazynowe faktur wysłanych do KSeF — faktury zostają
        invoicesToCheck = this.sentInvoiceHasWd
        mode = "only_wd"
      } else {
        invoicesToCheck = this.invoicesToDelete
        mode = "with_wd"
      }

      // DELETE /invoices/bulk_delete z jawną listą faktur (mode=with_wd|only_wd).
      this.listBulkOutlet.submitBulkForIds(invoicesToCheck, {
        url: this.bulkDeleteUrlValue,
        httpMethod: "delete",
        fields: { mode }
      })
    }
  }
}
